import React, {useEffect, useState} from 'react';
import './HomeSearch.css';
import SearchBar from '../SearchBar/SearchBar';

interface HeroSlide {
    backgroundImage: string;
    mobileBackgroundImage?: string;
    title: string;
}

const slides: HeroSlide[] = [
    {
        backgroundImage: require('../../assets/search-background.jpg'),
        mobileBackgroundImage: require('../../assets/search-background-mobile.jpg'),
        title: 'THE PRICE YOU SEE\nIS THE PRICE YOU PAY'
    },
    {
        backgroundImage: require('../../assets/search-background.jpg'),
        mobileBackgroundImage: require('../../assets/search-background-mobile.jpg'),
        title: 'NO HIDDEN FEES\nNO SURPRISES'
    },
    {
        backgroundImage: require('../../assets/search-background.jpg'),
        mobileBackgroundImage: require('../../assets/search-background-mobile.jpg'),
        title: 'EARN 5% BACK\nON EVERY PURCHASE'
    },
];

interface HomeSearchProps {
    onMobileSearchPressed?: () => void;
}

const HomeSearch: React.FC<HomeSearchProps> = ({onMobileSearchPressed = () => null}) => {
    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide(prev => (prev + 1) % slides.length);
        }, 5000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className='search-hero-container'>
            {slides.map((slide, index) => (
                <div
                    key={index}
                    className={`hero-slide ${index === currentSlide ? 'hero-slide-active' : ''}`}
                    style={{ backgroundImage: `url(${slide.backgroundImage})` }}
                />
            ))}
            <div className='hero-content'>
                <div className='hero-title' key={`title-${currentSlide}`}>
                    {slides[currentSlide].title.split('\n').map((line, i) => (
                        <span key={i}>{line}{i === 0 && <br />}</span>
                    ))}
                </div>
                <br/>
                <SearchBar onMobileSearchPressed={onMobileSearchPressed} />
                <div className='hero-dots'>
                    {slides.map((_, index) => (
                        <button
                            key={index}
                            className={`hero-dot ${index === currentSlide ? 'hero-dot-active' : ''}`}
                            onClick={() => setCurrentSlide(index)}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}

export default HomeSearch;
